import { Phone, Clock, TrendingUp, Users } from 'lucide-react';
import { getBrand } from '../brand';

export default function Stats({ stats }) {
  const brand = getBrand();
  const { total_calls, total_pulse, avg_pulse, active_agents } = stats;

  const formatPulse = (count) => `${count} pulse${count === 1 ? '' : 's'}`;

  const statsList = [
    { name: 'Total Calls', value: total_calls, icon: Phone, color: brand.accent },
    { name: 'Total Pulse', value: formatPulse(total_pulse), icon: Clock, color: brand.success },
    { name: 'Avg Pulse', value: formatPulse(avg_pulse), icon: TrendingUp, color: brand.warning },
    { name: 'Active Agents', value: active_agents, icon: Users, color: brand.primaryLight },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statsList.map((stat) => (
        <div
          key={stat.name}
          className="bg-surface rounded-xl border border-slate-200 shadow-sm p-5 relative overflow-hidden"
        >
          <div
            className="absolute top-0 left-0 w-full h-1"
            style={{ backgroundColor: stat.color }}
          ></div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-text-muted">{stat.name}</p>
              <p className="mt-1 text-2xl font-bold text-text-main">{stat.value}</p>
            </div>
            <div
              className="w-10 h-10 rounded-lg flex items-center justify-center"
              style={{ backgroundColor: stat.color + '15' }}
            >
              <stat.icon className="w-5 h-5" style={{ color: stat.color }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
